import getDefaultState from './defaultState';

export default getDefaultState();



// WEBPACK FOOTER //
// ./src/store/modules/itinerary/state.js